import logoVigilado from "../../../../assets/img/Logo_blanco_Vigilado_Vertical@4x.png";

export function MobileContainer ({children})
{
    return(
        <div style={{minHeight:"100dvh", height:"100%", 
        width:"100%", minWidth:"100dvw", 
        maxHeight:"100%", maxWidth:"100%",display:"flex"}}>
        <div style={{minHeight:"100dvh", height:"100%", 
        width:"100%", minWidth:"100dvw", 
        maxHeight:"100%", maxWidth:"100%",
        /*display: "flex", justifyContent:"center", 
        alignItems:"center", overflow:"hidden",*/
        }}>
            {children}            
        </div>
        <div style={{width:"50px", height:"100%", backgroundColor:"black",
            backgroundImage:"url("+logoVigilado+")", backgroundSize:"20px auto",
            backgroundRepeat:"no-repeat", backgroundPosition:"left calc(100% - 20px)",
        }}></div>
        </div>
    );
}